// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LandingPage\ApiLandingPage.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// LandingPageData is the class that LandingPage serializes to/from
export interface LandingPageData {
    Id : number;
	
	
    Hash : string | null;
    IsDefault : boolean;
    Name : string | null;
}

// LandingPageOptions is the class which may be passed to the LandingPage constructor to define optional initial data values
export interface LandingPageOptions {
    Id : number;
	
	
    Hash? : string | null;
    IsDefault? : boolean;
    Name? : string | null;
}

export class LandingPage {
    public Id : DataSignal<number>;
	
	
    public Hash : DataSignal<string | null>;
    public IsDefault : DataSignal<boolean>;
    public Name : DataSignal<string | null>;

    constructor();
    constructor(data : LandingPageOptions);
    constructor(data: LandingPageOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.Hash = jsonableObservable(S.value<string | null>(data && data.Hash !== undefined ? data.Hash : null));
        this.IsDefault = jsonableObservable(S.value<boolean>(data && data.IsDefault !== undefined ? data.IsDefault : false));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
    }

    static key(obj : LandingPage) {
        return obj.Id();
    }
    
    static dataKey(obj : LandingPageOptions) {
        return obj.Id;
    }

    static update(obj : LandingPage, data : LandingPageOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Hash !== undefined) obj.Hash(data.Hash);
            if (data.IsDefault !== undefined) obj.IsDefault(data.IsDefault);
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/LandingPage.ts